import React, { useEffect, useState } from 'react';

import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function DepositsStats() {
    const [data, setData] = useState({
        allDepositsCount: 0,
        successCount: 0,
        failureCount: 0,
        uniqueFailureCount: 0,
        pendingCount: 0,
    });
    const url = '/crea/api/deposit/stats';

    useEffect(() => {
        axios.get(url).then((response) => {
            setData(response.data);
        });
    }, []);

    return (
        <Card title="Last 30 days">
            <TableDetailsBody>
                <Row label="All deposits">{data.allDepositsCount}</Row>
                <Row label="Successful">{data.successCount}</Row>
                <Row label="Failures">{data.failureCount}</Row>
                <Row label="Unique Failures">{data.uniqueFailureCount}</Row>
                <Row label="Pending">{data.pendingCount}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default DepositsStats;
